import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const vatReportTypeSchema = z.enum(['intrastat', 'intervat', 'intracom']);
export type VatReportType = z.infer<typeof vatReportTypeSchema>;

const vatReportPeriodSchema = z.object({
  month: z.number().int().min(1).max(12).optional().nullable(),
  quarter: z.number().int().min(1).max(4).optional().nullable(),
  year: z.number().int(),
});

export const adminVatReportsContract = c.router({
  listVatReportVersions: {
    method: 'GET',
    path: '/admin/vat-reports/versions',
    responses: {
      200: z.array(
        z.object({
          tag: z.string(),
          revision: z.string(),
          createdAt: z.string().optional(),
          gitSha: z.string().optional(),
          ticket: z.string().optional(),
        }),
      ),
    },
  },
  generateVatReportVersion: {
    method: 'POST',
    path: '/admin/vat-reports/generate',
    body: vatReportPeriodSchema.extend({
      declarantId: z.string(),
      type: vatReportTypeSchema,
      version: z.string(),
    }),
    responses: {
      200: z.any(),
      400: z.object({ message: z.string() }),
      502: z.object({ message: z.string() }),
    },
  },
});

export const vatReportsRunnerContract = c.router({
  generateVatReport: {
    method: 'POST',
    path: '/internal/vat-reports/generate',
    body: vatReportPeriodSchema.extend({
      declarantId: z.string(),
      type: vatReportTypeSchema,
    }),
    responses: {
      200: z.any(),
      401: z.object({ message: z.string() }),
      404: z.object({ message: z.string() }),
    },
  },
});
